"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Panel = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("../../constants");
var _hooks = require("../../hooks");
var _types = require("../../types");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Panel = props => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const {
    capabilities,
    captionText,
    iconSize = 'medium',
    isCaptionIconDisplayed,
    isCopyLinkIconDisplayed = true,
    onError,
    onShareIconClick
  } = props;
  const {
    enabledVendors,
    error,
    isLoadingSharingConfig
  } = (0, _hooks.useSharingConfiguration)(capabilities, isCopyLinkIconDisplayed);
  const getIconProps = vendor => ({
    [_constants.VENDOR_DATA_ATTRIBUTE]: `${vendor}`,
    kind: vendor,
    onClick: async () => onShareIconClick(vendor),
    size: iconSize,
    tabIndex: 0,
    ...getTestIdProps(_types.TestId.Icon)
  });
  if (error) {
    // execute the error callback later to not interfere with current render
    // TO-DO: Maybe the same as a more standard useEffect()?
    setTimeout(() => {
      onError?.('Error loading sharing configuration.', error);
    });
    return null;
  }
  if (isLoadingSharingConfig || !enabledVendors.length) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    ...getTestIdProps(_types.TestId.Root),
    children: [captionText ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Caption, {
      ...getTestIdProps(_types.TestId.Caption),
      children: [isCaptionIconDisplayed ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CaptionShareIcon, {}) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: "body1",
        children: captionText
      })]
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Icons, {
      ...getTestIdProps(_types.TestId.Icons),
      children: enabledVendors.map(vendor => /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.SocialIcon, {
        ...getIconProps(vendor)
      }, vendor))
    })]
  });
};
exports.Panel = Panel;
var _default = exports.default = Panel;
